import { render, staticRenderFns } from "./result-detail.vue?vue&type=template&id=4ac8b46c&scoped=true"
import script from "./result-detail.vue?vue&type=script&lang=js"
export * from "./result-detail.vue?vue&type=script&lang=js"
import style0 from "./result-detail.vue?vue&type=style&index=0&id=4ac8b46c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac8b46c",
  null
  
)

export default component.exports